<template>
    <div>
        <b-row>
            <b-col sm="12">       
                <b-collapse visible>
                    <p class="mb-2">
                        <label>
                            Por favor tener en cuenta que los importes generados solo estarán disponibles por 2 horas         
                        </label>
                        <b-button class="float-right" variant="primary" @click="reloadImportes">
                            Actualizar consulta
                        </b-button>
                    </p>
                    <b-table
                        class="mt-3" 
                        responsive
                        striped 
                        hover 
                        :items="importes" 
                        :fields="columnas">                    
                    <template v-slot:cell(descargable)="data">
                            <span>
                                Procesado correctamente
                            </span>
                    </template>  
                    <template v-slot:cell(estado_procesamiento)="data">
                        <span v-if="!data.item.errores && data.item.estado_procesamiento">
                            {{ data.item.estado_procesamiento }}
                        </span>
                        <span v-else>
                            TERMINADO CON ERRORES <br />
                            {{ data.item.errores }}
                        </span>
                    </template>
                    </b-table>       
                </b-collapse>
            </b-col>     
        </b-row>
    </div>
</template>
<script> 
import { mapActions, mapMutations, mapState } from "vuex";
import loader from '../../containers/loader';

    export default {
        name: 'UsuariosMasivoAgendados',
        props: ['importes'],
        data() {
            return {
                loading: false,
                columnas:[
                {key: '', label: '', sortable: true, tdClass: 'descargableButton'},
                {key: 'empresa', label: 'Empresa', sortable: true, tdClass: 'empresaInforme'},
                {key: 'fecha_solicitud', label: 'Fecha de solicitud', sortable: true, tdClass: 'fechaSolicitud'},
                {key: 'fecha_generacion', label: 'Fecha de generación', sortable: true, tdClass: 'fechaGeneracion'},
                {key: 'estado_procesamiento', label: 'Estado de generación', sortable: true, tdClass: 'estadoGeneracion'}
            ],
            }
        },
        components: {
            loader
        },
        methods: {       
            async reloadImportes() {
                this.load(true);
                await this.listarImportesAgendados(this.selectedEmpresa.id);
                this.load(false);
            },
            ...mapActions("empresa", [
                'listarImportesAgendados'
            ]),
            ...mapMutations("dashboard", ["load"])
        },
        computed: {
            ...mapState('empresa', [
                'selectedEmpresa'
            ]),
        }
    }
</script>
<style scoped>
.descargableButton {
    width: 70px !important;
    max-width: 100px !important;
    min-width: 70px !important;
}
.fechaSolicitud {
    width: 100px !important;
    max-width: 100px !important;
    min-width: 100px !important;
}
.fechaGeneracion {
    width: 100px !important;
    max-width: 100px !important;
    min-width: 100px !important;
}
.estadoGeneracion {
    width: 140px !important;
    max-width: 140px !important;
    min-width: 140px !important;
}
.empresaInforme {
    width: 100px !important;
    max-width: 100px !important;
    min-width: 100px !important;
}
</style>